
    import { defineComponent } from 'vue'
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import InsurableAmount from '@/apps/shared/services/getInsurableAmount-service';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import ProductCardsSelector from '@/apps/shared/components/ProductCardsSelector.vue';
    import { TitleAndPromotionsDetails } from '@/apps/shared/models/titleAndPromotionsDetails';

    export default defineComponent({
        components: {
            XBreadcrumb,
            ProductCardsSelector
        },
        busEvents: {
            Next: function (data) {
                //prevenir que el evento Next y otras acciones de navegación se ejecuten de forma redundante
                if (data.fromTab === 'tab-three') {
                    if (this.$refs.productCards && this.$refs.productCards.isNavigationAllowed) {  // Comprobamos si la navegación está permitida
                        this.$router.push({
                            name: 'tabFourFamilyCombinedPremium',
                        });
                        this.$refs.productCards.isNavigationAllowed = false;  // Desactivamos la navegación
                    }
                }
            },
            SaveProductDataValueSession: function (value) {
                if (value.fromTab === 'tab-three') {
                    sessionStorage.removeItem('ProductValueSelected');
                    sessionStorage.setItem('ProductValueSelected', JSON.stringify(value));
                }
            },
        },
        data() {
            return {
                productCardsSelector: {
                    iconPromotion: null,
                    otherIconPromotion: null,
                    icon: null,
                    product: "",
                    title: "Valor de la vivienda",
                    subTitle: "Te ofrecemos opciones de suma asegurada para tu hogar. Elegí la que mejor se adapte a tus necesidades.",
                    tabName: "tab-three",
                } as TitleAndPromotionsDetails,
                /*isBack: false,*/
                breadcrumItems: [
                    { text: 'Inicio', path: '/hogar-premium' },
                    { text: 'Cotizá tu hogar', path: '/hogar-premium/cotizar' },
                    { text: 'Valor del hogar', path: '/hogar-premium/valor-vivienda' },
                ],
                buildingCapital: null,
                amountFormatted: null,
                amount: null,
                checkValid: false,
                values: [
                    {
                        amount: 0,
                        text: "",
                        category: ""
                    }
                ],
                dataTwoTabJson: null,
                backExit: false,
                referente: null,
                medium: null,
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Hogar Premium';
                const actualPath = '/hogar-premium';
                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, null, null);
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultFamilyCombinedGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            getInsurableAmount() {
                const dataTwoTab = sessionStorage.getItem("TabTwoData");
                if (dataTwoTab) {
                    this.dataTwoTabJson = JSON.parse(dataTwoTab);
                }
                if (this.dataTwoTabJson.articleCode && this.dataTwoTabJson.surfaceHouse) {
                    InsurableAmount.getInsurableAmount(this.dataTwoTabJson.articleCode.id, this.dataTwoTabJson.surfaceHouse).then((response) => {
                        if (response.length !== 0) {
                            this.values = response.map((element: any) => ({
                                ...element,
                                code: element["amount"],
                                productDescription: element["amountFormatted"],
                                category: element["category"]
                            }));
                              this.$refs.productCards.setProductData(this.values);
                        }
                        NF.UI.Page.unblock();
                    });
                }
                else {
                    NF.UI.Page.unblock();
                }

            },

            volver() {
                sessionStorage.setItem("pressBack", "true");
                this.$router.push({
                    name: 'tabTwoFamilyCombinedPremium',
                })
            },

            getInitData() {
                sessionStorage.setItem("ExitOrContinueModal", "true");
                NF.UI.Page.block();
                this.getInsurableAmount();
                var validBack = sessionStorage.getItem("pressBack");
                if (validBack) {
                    // Permite la navegación nuevamente cuando el componente regresa a este tab
                    this.$refs.productCards.resetNavigationFlag();
                    var productData = JSON.parse(sessionStorage.getItem("ProductValueSelected"));
                    if (productData) {
                        //Llama a la funcion de productCardsSelector.vue, luego de que regresan la pantalla y muestra la opcion elegida
                        this.$refs.productCards.getDataProductBack(productData);
                    }
                }
            }
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente;
                var medium = sessionStorage.getItem("Medium");
                medium == 'null' || medium == null ? this.medium = 'organic' : this.medium = medium; 

                const parallelPromises = [
                    this.pageCustomization(),
                    this.updateByProductGoogleAnalytics(),
                    this.getInitData()
                ];

                await Promise.all([
                    ...parallelPromises,
                ]);

                window.globalThis.dataLayer.push({
                    'pas': null,
                    'email': JSON.parse(sessionStorage.getItem("TabOneWelcome")).email,
                    'product': 'hogar-premium',
                    'event': 'cotizador-hogar-premium-valor-vivienda',
                    'referente': this.referente,
                    'medio': this.medium
                });

            } finally {
                NF.UI.Page.unblock();
            }
        },
    });
